export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";